import React from 'react'

const Banner = ({message}) => {
	return (
    <div className="hero">
      <div className="container section">
        <p className="text-size-2 text-weight-bold text-centered">{message}</p>
      </div>
    </div>
	)
}

export default Banner